import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { filter, map } from 'rxjs/operators';
import {
    AppointmentListService } from '../appointment-list/state/appointment-list.service';

@Component({
    selector: 'appointment-log-xmllog',
    templateUrl: './appointment-log-xmllog.component.html'
})

export class AppointmentLogXmllogComponent implements OnInit {

    loading: boolean;
    appointmentXmlLog$: Observable<Array<any>>;
    viewModel$: Observable<any>;
    lineWrapping = true;
    selectedLog: any;
    @Input() selectedXmlIdList: any;
    @Input() uuid: any;
    @Input() selectedTimeZone;

    constructor(public store: Store<any>,
                private appointmentListService: AppointmentListService) {
    }

    ngOnInit(): void {
        if (this.uuid !== undefined && this.uuid !== null) {
            this.appointmentXmlLog$ = this.appointmentListService.getXMLLog(this.uuid);
            this.loading = true;
            this.viewModel$ =
                this.appointmentXmlLog$
                    .pipe(
                        filter(logs => logs !== undefined),
                        map(logs => {
                            this.loading = false;

                            return logs;
                        })
                    );
        }

    }

    isXmlIdSelected(id): boolean {
        if (this.selectedXmlIdList !== undefined) {
            return this.selectedXmlIdList.indexOf(id) !== -1;
        }

        return false;
    }

    getCodeMirrorOptions(): any {
        return {
            lineWrapping: this.lineWrapping,
            lineNumbers: true,
            readOnly: true,
            mode: 'application/ld+xmlin',
            formatting : true
        };
    }

}
